document.addEventListener('DOMContentLoaded', function() {
  if (window.jQuery) {
    let $ = window.jQuery;
    $(function() {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 3);
      let formattedDate = $.datepicker.formatDate('yy-mm-dd', tomorrow);
      $('[id^="pickup-date"]').val(formattedDate);
      
      $('[id^="pickup-date"]').datepicker({
        minDate: +3,
        beforeShowDay: $.datepicker.noWeekends,
        dateFormat: 'yy-mm-dd'
      });
    });
  }
});